import React from "react";
import PropTypes from "prop-types";
import { cold } from "react-hot-loader";

import {
    createDrawerNavigator, 
} from '@react-navigation/drawer';

import { NavigationContainer, DefaultTheme, } from '@react-navigation/native';

import { useColor } from "~/native-ui/hooks";
import { useColorModeValue } from "~/native-ui/native-base";

import DrawerContent from "./DrawerContent";
import { navigatorContainerProps, } from "./navigatorContainerProps";
import { navigatorDefaultProps } from "./navigatorDefaultProps";

const Drawer = createDrawerNavigator();


cold(Drawer);
cold(Drawer.Screen);


const NavigationContainerWithTheme = (props) => {
    const [lightBg, darkBg] = useColor("coolGray.100", "dark.100");
    const background = useColorModeValue(lightBg, darkBg);
    const setRef = React.useCallback((ref) => { navigatorContainerProps.ref.current = ref }, [ navigatorContainerProps ]);

    const theme = {
        ...DefaultTheme,
        colors: {
          ...DefaultTheme.colors,
          background
        },
      };
      
    return <NavigationContainer { ...props } { ...navigatorContainerProps } ref={ setRef } theme={ theme } />
}
  

export class DrawerNavigator extends React.Component {
    static propTypes = {
        showDrawer: PropTypes.bool,
        isSmallScreen: PropTypes.bool,
        drawerContent: PropTypes.any,
        screens: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.node.isRequired,
                component: PropTypes.any,
            })
        ).isRequired
    }


    renderDrawerContent = (props) => {
        return (
            <DrawerContent {...props} showDrawer={this.props.showDrawer} key={this.isSmallScreen + ""}>
                {this.props.drawerContent}
            </DrawerContent>
        );
    }

    renderScreens () {
        return this.props.screens.map((screen, i) => (
            <Drawer.Screen key={ screen.name + i } { ...screen} />
        ))
    }
    
    render() {
        const navigatorProps = {
            drawerContent: this.props.drawerContent ? this.renderDrawerContent : undefined,
            ...navigatorDefaultProps(this.props),
        }

        return (
            <NavigationContainerWithTheme>
                <Drawer.Navigator { ...navigatorProps}>
                    {this.renderScreens()}
                </Drawer.Navigator>
            </NavigationContainerWithTheme>
        )
    }
}